import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _parseInt from '@babel/runtime-corejs3/core-js/parse-int';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js/instance/map';
import React__default from 'react';
import { login } from '@bilibili-maoer/web-utils';
import classNames from 'classnames';
import { toggleModal } from '../modal/legacy-modal/index.js';
import { toggleToast } from '../toast/index.js';
import '../utils/fetcher.js';
import { prependPrefix } from '../utils/style.js';
import { report } from './api.js';
import { EReportReason } from './enum.js';
export { EResourceType } from './enum.js';

var _REASON_LABELS_MAP;
var REASON_LABELS_MAP = (_REASON_LABELS_MAP = {}, _defineProperty(_REASON_LABELS_MAP, EReportReason.Advertisement, '广告'), _defineProperty(_REASON_LABELS_MAP, EReportReason.CopyrightInfringement, '版权'), _defineProperty(_REASON_LABELS_MAP, EReportReason.Pornography, '色情'), _defineProperty(_REASON_LABELS_MAP, EReportReason.Politic, '政治'), _defineProperty(_REASON_LABELS_MAP, EReportReason.Other, '其他'), _REASON_LABELS_MAP);
var toggleReportModal = function toggleReportModal(target) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var ReportContent = function ReportContent(close) {
    var reasons = [EReportReason.Advertisement, EReportReason.Pornography, EReportReason.CopyrightInfringement, EReportReason.Politic, EReportReason.Other];

    var handleSubmit = function handleSubmit(e) {
      e.preventDefault();
      var formData = new FormData(e.currentTarget);
      var formReason = formData.get('reason');
      var reason = formReason ? _parseInt(formReason) : null;
      var content = formData.get('content');

      if (reason === EReportReason.Other && !content) {
        toggleToast('请填写举报理由');
        return;
      }

      report(target, {
        reason: reason,
        content: content
      }).then(function () {
        toggleToast('举报成功');
        close();
      }).catch(function (err) {
        if (err.isLoginRequired) {
          if (options.login) {
            options.login();
          } else {
            login.gotoLogin();
          }

          return;
        }

        toggleToast(err.message);
      });
    };

    var handleCancel = function handleCancel() {
      close();
    };

    return /*#__PURE__*/React__default.createElement("form", {
      className: prependPrefix('report-modal'),
      onSubmit: handleSubmit
    }, /*#__PURE__*/React__default.createElement("div", null, "\u8BF7\u9009\u62E9\u4E3E\u62A5\u7684\u7406\u7531"), _mapInstanceProperty(reasons).call(reasons, function (reason) {
      var reasonLabel = REASON_LABELS_MAP[reason];
      return /*#__PURE__*/React__default.createElement("div", {
        className: "option",
        key: reason
      }, /*#__PURE__*/React__default.createElement("input", {
        type: "radio",
        name: "reason",
        value: reason,
        id: reasonLabel
      }), /*#__PURE__*/React__default.createElement("label", {
        htmlFor: reasonLabel
      }, reasonLabel));
    }), /*#__PURE__*/React__default.createElement("textarea", {
      name: "content",
      placeholder: "\u8BE6\u7EC6\u63CF\u8FF0\u6216\u5176\u4F59\u539F\u56E0\u8BF7\u5728\u6B64\u586B\u5199",
      draggable: false
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "bottom"
    }, /*#__PURE__*/React__default.createElement("button", {
      className: "btn-confirm",
      type: "submit"
    }, "\u786E\u5B9A"), /*#__PURE__*/React__default.createElement("button", {
      className: "btn-cancel",
      type: "button",
      onClick: handleCancel
    }, "\u53D6\u6D88")));
  };

  toggleModal({
    // type: 'message',
    title: '举报',
    // HACK: message 样式的模态框最符合需求，但是 message 样式只会渲染一个取消按钮，无法渲染确认按钮。
    // 为了重用 message 样式，使用了内部具体实现的 message-modal 作为类名。将来调整后可以去除掉 HACK。
    className: classNames('message-modal', options.className),
    cancel: true,
    content: ReportContent
  });
};

export { toggleReportModal };
